// import React from "react";

// function DashboardMobilePage() {
//   return <div>dashboard mobile</div>;
// }

// export default DashboardMobilePage;

import React from "react";
import { Accordion } from "react-rainbow-components";
import { Names } from "react-rainbow-components/components/ActivityTimeline";
import { AccordionSectionCustom, Container, HeaderTitle } from "./index.style";
import { ProfileComponent } from "../../../components/common/ProfileComponent";
import { CardSummary } from "../../../components/databaseAdminComponent/CardSummary";
import { IPaymentTracking } from "../../../interfaces/paymentTracking";
import { IPets } from "../../../interfaces/pets";
import dayjs from "dayjs";
interface PropsType {
  bookings: IPaymentTracking[];
  getPet: (pets: IPets[], pid: string) => IPets | undefined;
  setDataCard: (data: IPaymentTracking) => void;
  isLoading: boolean;
  dataCard: IPaymentTracking;
  handleSubmit: () => void;
  handleChangeTage: (tags: string[]) => void;
}

export default function useChatPage({
  bookings,
  getPet,
  setDataCard,
  isLoading,
  dataCard,
  handleSubmit,
  handleChangeTage,
}: PropsType) {
  const [activeNames, setActiveNames] = React.useState<Names>([]);
  const handleOnSelect = (
    _: React.MouseEvent<HTMLElement, MouseEvent>,
    activeNames: Names
  ) => setActiveNames(activeNames);

  return (
    <Container>
      <HeaderTitle>
        <h1 className="text-n-color">Dashboard</h1>
        <p className="text-h-color">
          {dayjs(new Date()).format("ddd, DD MMM YYYY")}
        </p>
      </HeaderTitle>
      <Accordion
        id="accordion-multiple-1"
        multiple
        activeSectionNames={activeNames}
        onToggleSection={handleOnSelect}
        style={{ width: "100%" }}
      >
        {bookings.map((item, index) => {
          const pet = getPet(item.pets || [], item.pid);
          return (
            <div onClick={() => setDataCard(item)} key={index}>
              <AccordionSectionCustom
                name={item.bookingId}
                label={
                  <ProfileComponent
                    style={{ minWidth: 0 }}
                    styleImader={{
                      marginLeft: 0,
                      width: "2.5rem",
                      height: "2.5rem",
                    }}
                    name={
                      item.status === 4
                        ? item.displayName + " (ติดตามผล)"
                        : item.displayName
                    }
                    lineId={`สัตว์เลี้ยง: ${pet?.petName}`}
                    avatar={item.imageUrl}
                  />
                }
              >
                <CardSummary
                  isLoading={isLoading}
                  booking={dataCard}
                  handleSubmit={handleSubmit}
                  handleChangeTage={handleChangeTage}
                />
              </AccordionSectionCustom>
            </div>
          );
        })}
      </Accordion>
    </Container>
  );
}
